module.exports = __webpack_public_path__ + "static/Spring-5f2ea319e657420e6bd11ac8e712687a.jpg";